/**
 * Куда ведёт кнопка теста в задаче плана.
 *
 * 'continue' — открыть уже начатый, но не завершённый тест;
 * 'start'    — попросить бэкенд создать новую попытку.
 *
 * Баг 08.09.2026: у проваленного гейта бэкенд ставит is_completed=false,
 * а test_id по-прежнему указывает на завершённый тест. Старая проверка
 * «есть test_id и задача не выполнена» вела в старый тест с уже отвеченными
 * вопросами вместо новой попытки. Признак результата — test_score > 0:
 * балл ставится только при завершении теста.
 */
export function resolveTestAction(task, isGateType) {
    if (!task?.test_id) return 'start';
    // test_completed приходит с бэкенда (14.09.2026): при 0% балл не отличим от «не решал».
    const hasResult = task.test_completed || (task.test_score || 0) > 0 || task.is_completed || (isGateType && task.gate_passed);
    return hasResult ? 'start' : 'continue';
}
